export default __webpack_public_path__ + "img/catIcon297.5efa8a81.svg";